export interface RankItem {
  rank: number;
  title: string;
  category: string;
  heat: number;
  heatText: string;
  tag: string;
  tagType: "primary" | "accent" | "secondary" | "foreground";
  time: string;
  trend: "up" | "down" | "flat" | "new";
  hot?: boolean;
}

export interface FeatureCard {
  id: string;
  title: string;
  category: string;
  excerpt: string;
  image: string;
  views: string;
  comments: string;
  time: string;
  tag: string;
}

export interface FaqItem {
  q: string;
  a: string;
}

export const todayHot: RankItem[] = [
  { rank: 1, title: "顶流综艺收官夜 · 冠军结果引发全网热议", category: "综艺", heat: 998, heatText: "9800万+", tag: "爆", tagType: "primary", time: "刚刚", trend: "new", hot: true },
  { rank: 2, title: "青年男演员片场路透流出 · 新剧造型反差惊艳", category: "娱乐八卦", heat: 962, heatText: "8300万+", tag: "热", tagType: "accent", time: "3分钟前", trend: "up" },
  { rank: 3, title: "一线歌手新专辑主打单曲音源试听片段曝光", category: "音乐", heat: 918, heatText: "7200万+", tag: "热", tagType: "accent", time: "8分钟前", trend: "up" },
  { rank: 4, title: "城市晚高峰地铁失物招领暖心接力走红", category: "社会热点", heat: 875, heatText: "6600万+", tag: "暖", tagType: "secondary", time: "12分钟前", trend: "up" },
  { rank: 5, title: "老牌制作人回归访谈 · 回忆录金句刷屏", category: "影视", heat: 823, heatText: "5900万+", tag: "热", tagType: "accent", time: "16分钟前", trend: "flat" },
  { rank: 6, title: "高校创意毕业照火出圈 · 网友直呼脑洞大", category: "生活趣闻", heat: 776, heatText: "5300万+", tag: "趣", tagType: "secondary", time: "22分钟前", trend: "up" },
  { rank: 7, title: "夏季热门饮品品牌联名 · 门店大排长龙", category: "消费", heat: 741, heatText: "4800万+", tag: "热", tagType: "accent", time: "27分钟前", trend: "down" },
  { rank: 8, title: "国产科幻新片预告释出 · 视效获影迷好评", category: "影视", heat: 702, heatText: "4100万+", tag: "新", tagType: "foreground", time: "33分钟前", trend: "new" },
  { rank: 9, title: "奥运冠军现身母校 · 小学生追星现场温馨", category: "体育", heat: 668, heatText: "3600万+", tag: "暖", tagType: "secondary", time: "40分钟前", trend: "up" },
  { rank: 10, title: "周末出游高峰 · 多条热门线路预订量攀升", category: "社会热点", heat: 612, heatText: "2900万+", tag: "升", tagType: "accent", time: "46分钟前", trend: "up" },
];

export const weekRank: RankItem[] = [
  { rank: 1, title: "全民追剧 · 现象级古装剧大结局收视破纪录", category: "影视", heat: 999, heatText: "9.6亿+", tag: "TOP1", tagType: "primary", time: "本周", trend: "flat", hot: true },
  { rank: 2, title: "顶流歌手巡回演唱会开票秒空 · 黄牛话题再起", category: "娱乐八卦", heat: 941, heatText: "8.1亿+", tag: "热", tagType: "accent", time: "本周", trend: "up" },
  { rank: 3, title: "年度盛典红毯造型盘点 · 谁是你的心中最佳", category: "时尚", heat: 887, heatText: "7.4亿+", tag: "热", tagType: "accent", time: "本周", trend: "up" },
  { rank: 4, title: "新晋小花感情传闻发酵 · 工作室火速回应", category: "娱乐八卦", heat: 830, heatText: "6.6亿+", tag: "爆", tagType: "primary", time: "本周", trend: "up" },
  { rank: 5, title: "脱口秀演员段子集锦 · 金句持续刷屏社交平台", category: "综艺", heat: 779, heatText: "5.9亿+", tag: "趣", tagType: "secondary", time: "本周", trend: "down" },
  { rank: 6, title: "夏日高温持续 · 各地避暑新玩法走红", category: "生活趣闻", heat: 731, heatText: "5.2亿+", tag: "升", tagType: "accent", time: "本周", trend: "up" },
  { rank: 7, title: "热门手游夏日版本更新 · 新角色引玩家热议", category: "游戏", heat: 690, heatText: "4.7亿+", tag: "热", tagType: "accent", time: "本周", trend: "up" },
  { rank: 8, title: "非遗技艺传承短视频走红 · 00后爱上传统手艺", category: "文化", heat: 648, heatText: "4.1亿+", tag: "暖", tagType: "secondary", time: "本周", trend: "new" },
  { rank: 9, title: "城市深夜食堂纪录片热播 · 治愈无数打工人", category: "社会热点", heat: 602, heatText: "3.5亿+", tag: "暖", tagType: "secondary", time: "本周", trend: "flat" },
  { rank: 10, title: "人气偶像团体新曲舞台 · 舞蹈挑战全网跟跳", category: "音乐", heat: 554, heatText: "2.9亿+", tag: "趣", tagType: "secondary", time: "本周", trend: "down" },
];

export const featureCards: FeatureCard[] = [
  {
    id: "fenomenal-drama",
    title: "现象级古装剧为何能连续霸榜热搜？",
    category: "影视解析",
    excerpt: "从剧情节奏、服化道到演员二创，拆解这部爆款剧制霸整个夏天的流量密码。",
    image: "https://readdy.ai/api/search-image?query=cinematic%20ancient%20chinese%20costume%20drama%20scene%20with%20dramatic%20palace%20interior%20and%20warm%20lantern%20light%2C%20rich%20warm%20coral%20and%20golden%20tones%2C%20epic%20storytelling%20mood%2C%20editorial%20photography&width=1200&height=800&seq=gossip-feature-1&orientation=landscape",
    views: "1280万",
    comments: "3.2万",
    time: "2小时前",
    tag: "深度",
  },
  {
    id: "concert-ticket",
    title: "演唱会开票秒空的背后，票务乱象何时休？",
    category: "行业观察",
    excerpt: "一票难求与高价黄牛并存，追星这件事正在变成一门越来越贵的生意。",
    image: "https://readdy.ai/api/search-image?query=concert%20stage%20with%20vibrant%20pink%20and%20coral%20stage%20lights%20and%20silhouette%20of%20crowd%20waving%20lightsticks%2C%20energetic%20atmosphere%2C%20warm%20glow%2C%20editorial%20concert%20photography&width=1200&height=800&seq=gossip-feature-2&orientation=landscape",
    views: "986万",
    comments: "2.7万",
    time: "5小时前",
    tag: "热议",
  },
  {
    id: "red-carpet",
    title: "红毯造型盘点：明星穿搭审美天花板在这了",
    category: "时尚盘点",
    excerpt: "惊艳全场的高级定制与翻车现场，一场盛典把圈内时尚功力照得清清楚楚。",
    image: "https://readdy.ai/api/search-image?query=elegant%20red%20carpet%20glamour%20scene%20with%20fashionable%20dresses%20and%20flash%20photography%20in%20warm%20coral%20and%20cream%20tones%2C%20luxury%20evening%20gown%20details%2C%20editorial%20fashion%20photography&width=1200&height=800&seq=gossip-feature-3&orientation=landscape",
    views: "854万",
    comments: "1.9万",
    time: "8小时前",
    tag: "盘点",
  },
  {
    id: "talk-show",
    title: "脱口秀爆梗背后，戳中了多少当代年轻人的心事",
    category: "综艺趣谈",
    excerpt: "那些让人捧腹又心酸的段子，说的正是普通人的职场与生活日常。",
    image: "https://readdy.ai/api/search-image?query=comedy%20talk%20show%20stage%20with%20single%20spotlight%20and%20microphone%20stand%2C%20playful%20warm%20lighting%2C%20audience%20silhouettes%20laughing%2C%20editorial%20entertainment%20photography&width=1200&height=800&seq=gossip-feature-4&orientation=landscape",
    views: "760万",
    comments: "1.5万",
    time: "12小时前",
    tag: "趣闻",
  },
];

export const categories = [
  { key: "ent", name: "娱乐八卦", icon: "ri-fire-line", count: "今日 48 条" },
  { key: "tv", name: "影视综艺", icon: "ri-movie-2-line", count: "今日 36 条" },
  { key: "music", name: "音乐时尚", icon: "ri-mic-line", count: "今日 29 条" },
  { key: "society", name: "社会热点", icon: "ri-earth-line", count: "今日 42 条" },
  { key: "life", name: "生活趣闻", icon: "ri-empathize-line", count: "今日 33 条" },
  { key: "sports", name: "体育游戏", icon: "ri-trophy-line", count: "今日 25 条" },
];

export const faqItems: FaqItem[] = [
  {
    q: "吃瓜精选的每日热门榜是如何生成的？",
    a: "吃瓜精选热门榜通过聚合多平台公开话题数据，结合讨论量、传播速度与用户互动等维度加权计算，形成每日滚动的热度TOP榜单，确保你看到的是当日最具话题性的焦点事件。",
  },
  {
    q: "本周排行与今日热门榜有什么区别？",
    a: "今日热门榜反映的是当天的实时热点，更新频率高；本周排行则汇总过去七天累计热度最高的吃瓜精选爆款话题，更适合你回看和了解一整周的瓜田脉络。",
  },
  {
    q: "更新频率是多久一次？",
    a: "今日榜通常以分钟级滚动更新，热度TOP事件出现时我们会第一时间收录；周榜则固定于每日滚动累计，周一对上一周数据做总盘点。",
  },
  {
    q: "我想看到某一类特定话题，该怎么办？",
    a: "你可以使用站内分类筛选功能，按娱乐八卦、影视综艺、社会热点等栏目快速定位自己关心的领域，不必在海量信息里逐条翻找。",
  },
  {
    q: "这里的上榜话题可以转发分享吗？",
    a: "当然可以。每条爆款话题都支持一键复制链接与分享，方便你随时把最新鲜的瓜田动态分享给好友，一起参与讨论。",
  },
];